import { w as withConfigTransport } from "../../../../services/config-transport/withConfigTransport-31ef3979.mjs";
import { _ as _VaSelectOption } from "./VaSelectOption-c233cb09.mjs";
const VaSelectOption = withConfigTransport(_VaSelectOption);
export {
  VaSelectOption as V
};
//# sourceMappingURL=index-c22d8d3b.mjs.map
